import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Popup, FilterSection, FilterActionButtons } from "components/molecules";

import "./FilterDropdown.scss";

const FilterDropdown = ({
	label,
	icon: Icon,
	options,
	selectedOptions,
	onToggleOption,
	onClearAll,
	onSelectAll,
	isOpen,
	onToggle,
	className,
	showActions,
	clearAllText,
	selectAllText,
	disabled,
	footer,
	position
}) => {
	const selectedCount = selectedOptions.length;
	const hasSelections = selectedCount > 0;
	const optionsCount = Array.isArray(options) ? options.length : Object.keys(options).length;
	const allSelected = selectedCount === optionsCount;

	const triggerButton = (
		<button
			type="button"
			className={classnames("filter-dropdown-trigger", { "is-open": isOpen })}
			disabled={disabled}
		>
			<span className="filter-label">
				{Icon && <Icon className="filter-icon" />}
				{label}
				{hasSelections && (
					<span className="filter-count">{selectedCount}</span>
				)}
			</span>
		</button>
	);

	const panelContent = (
		<div className="filter-dropdown-panel">
			{showActions && (
				<div className="filter-actions">
					<span className="filter-title">{label}</span>
					<FilterActionButtons
						onClearAll={onClearAll}
						onSelectAll={onSelectAll}
						clearAllText={clearAllText}
						selectAllText={selectAllText}
						hasSelections={hasSelections}
						allSelected={allSelected}
					/>
				</div>
			)}

			<FilterSection
				options={options}
				selectedOptions={selectedOptions}
				onToggleOption={onToggleOption}
				footer={footer}
				className="filter-dropdown-options"
			/>
		</div>
	);

	return (
		<Popup
			buttonContent={triggerButton}
			position={position}
			open={isOpen}
			onToggle={onToggle}
			className={classnames("filter-dropdown", className, {
				"is-disabled": disabled
			})}
		>
			{panelContent}
		</Popup>
	);
};

FilterDropdown.propTypes = {
	label: PropTypes.string.isRequired,
	icon: PropTypes.elementType,
	options: PropTypes.oneOfType([
		// Array format
		PropTypes.arrayOf(
			PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.shape({
					value: PropTypes.string.isRequired,
					label: PropTypes.string.isRequired
				})
			])
		),
		// Object format from Redux
		PropTypes.objectOf(
			PropTypes.shape({
				value: PropTypes.string.isRequired,
				label: PropTypes.string.isRequired
			})
		)
	]).isRequired,
	selectedOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
	onToggleOption: PropTypes.func.isRequired,
	onClearAll: PropTypes.func,
	onSelectAll: PropTypes.func,
	isOpen: PropTypes.bool.isRequired,
	onToggle: PropTypes.func.isRequired,
	className: PropTypes.string,
	showActions: PropTypes.bool,
	clearAllText: PropTypes.string,
	selectAllText: PropTypes.string,
	disabled: PropTypes.bool,
	footer: PropTypes.node,
	position: PropTypes.oneOf(["bottom-left", "bottom-right", "top-left", "top-right"])
};

FilterDropdown.defaultProps = {
	icon: null,
	onClearAll: () => {},
	onSelectAll: () => {},
	className: "",
	showActions: true,
	clearAllText: "Clear All",
	selectAllText: "Select All",
	disabled: false,
	footer: null,
	position: "bottom-left"
};

export default FilterDropdown;
